export default {
  monthYear: '%{month} %{year}',
  monthDay: '%{month} %{day}',
  quarterYear: 'Q%{quarter} %{year}',
  weekOf: 'Week of %{date}',
  dateAtTime: '%{date} at %{time}',
}
